import { inject as N, ref as x, computed as n, createBlock as L, createElementBlock as j, createCommentVNode as C, openBlock as w, unref as R, mergeProps as b, withCtx as T, renderSlot as y } from "vue";
import { RouterLink as V } from "vue-router";
const W = ["href", "target", "rel", "aria-label", "download"], E = "link-clicked", O = /* @__PURE__ */ Object.assign({
  name: "DsAnchorElement"
}, {
  __name: "anchor-element",
  props: {
    /**
     * trackingData, to be set as data-track attributes for tracking purpose
     */
    trackingData: { type: Object, default: () => ({}) },
    /**
     * url, href attribute content
     */
    url: { type: String, required: !1, default: null },
    /**
     * openInNewWindow, when is set to true it will open the link in a new window
     */
    openInNewWindow: { type: Boolean, default: !1 },
    /**
     * nuxt, when is set to true it will render a nuxt link (vue router link)
     */
    nuxt: { type: Boolean, default: !0 },
    /**
     * prefetch, when is set to true it will nuxt will prefetch the page
     */
    prefetch: { type: Boolean, default: !0 },
    /**
     * ariaLabel, arial-label attribute content
     */
    ariaLabel: { type: String, default: "" },
    /**
     * download, adds download attribute
     */
    download: { type: Boolean, required: !1, default: null }
  },
  emits: ["link-clicked"],
  setup(a, { emit: B }) {
    const t = a, D = B, o = N("trackEvent", null), u = x(), c = n(() => t.openInNewWindow ? "_blank" : null), i = n(() => t.openInNewWindow ? "noopener" : null), d = (e) => {
      var g, m, p, h;
      const r = ((p = (m = (g = e == null ? void 0 : e.target) == null ? void 0 : g.innerText) == null ? void 0 : m.replace(/(\r\n|\n|\r)/gm, " ")) == null ? void 0 : p.trim()) || ((h = e == null ? void 0 : e.target) == null ? void 0 : h.ariaLabel), l = {
        url: t.url,
        ...r && { label: r }
      };
      o ? o(E, l, e == null ? void 0 : e.currentTarget) : D(E, l);
    }, f = n(() => t.trackingData ? Object.keys(t.trackingData).reduce((e, r) => {
      const l = `data-track-${r}`;
      return e[l] || (e[l] = t.trackingData[r]), e;
    }, {}) : {}), s = n(() => {
      var e;
      return t.nuxt ? (e = t.url) == null ? void 0 : e.startsWith("http") : !0;
    }), k = n(() => t.url || "#");
    return (e, r) => s.value ? s.value ? (w(), j("a", b({
      key: 1,
      ref_key: "linkRef",
      ref: u,
      href: k.value,
      target: c.value,
      rel: i.value,
      "aria-label": a.ariaLabel
    }, f.value, {
      download: a.download ? "" : null,
      onClick: d
    }), [
      y(e.$slots, "default")
    ], 16, W)) : C("", !0) : (w(), L(R(V), b({
      key: 0,
      ref_key: "linkRef",
      ref: u,
      to: k.value,
      target: c.value,
      rel: i.value,
      "aria-label": a.ariaLabel,
      prefetch: a.prefetch,
      download: a.download ? "" : null
    }, f.value, { onClick: d }), {
      default: T(() => [
        y(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["to", "target", "rel", "aria-label", "prefetch", "download"]));
  }
});
export {
  O as default
};
